var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g, _g2, _path13, _path14, _g3, _path15, _path16, _path17, _path18, _g4, _g5, _g6, _g7, _g8, _path19, _path20, _path21, _path22, _g9, _g10, _g11, _g12, _g13, _g14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClaimsmile5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint0_radial_2548_3751)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint1_radial_2548_3751)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint2_radial_2548_3751)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint3_radial_2548_3751)",
    fillOpacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint4_radial_2548_3751)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint5_radial_2548_3751)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint6_radial_2548_3751)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint7_radial_2548_3751)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9985 44.997C37.9995 44.997 44.997 35.595 44.997 23.997C44.997 12.402 37.9995 3 23.997 3C9.9975 3 3 12.402 3 23.9985C3 35.595 9.996 44.997 23.9985 44.997Z",
    fill: "url(#paint8_radial_2548_3751)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9961 28.1396C42.3098 28.1396 44.9961 25.4534 44.9961 22.1396C44.9961 18.8259 42.3098 16.1396 38.9961 16.1396C35.6824 16.1396 32.9961 18.8259 32.9961 22.1396C32.9961 25.4534 35.6824 28.1396 38.9961 28.1396Z",
    fill: "url(#paint9_radial_2548_3751)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9 28.1396C12.3137 28.1396 15 25.4534 15 22.1396C15 18.8259 12.3137 16.1396 9 16.1396C5.68629 16.1396 3 18.8259 3 22.1396C3 25.4534 5.68629 28.1396 9 28.1396Z",
    fill: "url(#paint10_radial_2548_3751)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.5C15.6435 23.7 18.2145 27 24 27C29.7855 27 32.3565 23.7 33 22.5",
    stroke: "url(#paint11_radial_2548_3751)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.4062 15.9844C28.4062 15.9844 29.3318 13.7014 31.6868 14.1094C34.7393 14.6374 34.9688 17.6254 34.9688 17.6254",
    stroke: "url(#paint12_radial_2548_3751)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4688 15.9844C12.4688 15.9844 13.3943 13.7014 15.7493 14.1094C18.8018 14.6374 19.0312 17.6254 19.0312 17.6254",
    stroke: "url(#paint13_radial_2548_3751)",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5C12 16.5 12.375 13.5 15.75 13.5C19.125 13.5 19.5 16.5 19.5 16.5",
    stroke: "url(#paint14_radial_2548_3751)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 16.5C28.5 16.5 29.25 13.5 32.25 13.5C35.25 13.5 36 16.5 36 16.5",
    stroke: "url(#paint15_radial_2548_3751)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.13868 29.0429C6.42646 28.7006 6.83834 28.4866 7.28385 28.4478C7.72935 28.409 8.17204 28.5486 8.51468 28.8359L12.9727 32.5754L12.5977 31.2299C12.532 31.0063 12.5115 30.7719 12.5375 30.5403C12.5634 30.3087 12.6351 30.0846 12.7486 29.881C12.8621 29.6774 13.0149 29.4985 13.1983 29.3547C13.3816 29.2108 13.5918 29.1049 13.8165 29.0432C14.0412 28.9814 14.276 28.965 14.5071 28.995C14.7382 29.0249 14.961 29.1006 15.1626 29.2176C15.3641 29.3346 15.5404 29.4905 15.681 29.6764C15.8216 29.8622 15.9238 30.0742 15.9817 30.2999L17.0152 34.1084L18.2692 37.1264C18.2932 37.1824 18.3132 37.2384 18.3292 37.2944C18.7777 38.1569 19.0297 39.1409 19.0297 40.1849C19.0297 43.5989 16.3222 46.3649 12.9832 46.3649C11.5132 46.3649 10.1662 45.8309 9.11918 44.9399L2.39468 39.9944C2.12422 39.7958 1.91668 39.5235 1.79685 39.21C1.67702 38.8966 1.64998 38.5552 1.71895 38.2268C1.78792 37.8984 1.94999 37.5968 2.18579 37.3581C2.4216 37.1193 2.72116 36.9535 3.04868 36.8804L2.40968 36.3449C2.15571 36.1315 1.96699 35.8509 1.86516 35.5352C1.76332 35.2195 1.75249 34.8815 1.8339 34.5599C1.91531 34.2384 2.08567 33.9462 2.32546 33.717C2.56525 33.4878 2.86476 33.3308 3.18968 33.2639L2.99168 33.0989C2.80999 32.9512 2.6595 32.7688 2.54898 32.5624C2.43845 32.356 2.37009 32.1296 2.34788 31.8965C2.32566 31.6634 2.35004 31.4282 2.41959 31.2046C2.48915 30.9811 2.60248 30.7735 2.753 30.5942C2.90352 30.4148 3.08822 30.2672 3.29634 30.1598C3.50446 30.0525 3.73185 29.9877 3.96527 29.9691C4.19869 29.9505 4.43347 29.9786 4.65595 30.0516C4.87844 30.1246 5.08417 30.2411 5.26118 30.3944L5.99018 31.0049C5.62418 30.4049 5.66018 29.6114 6.13868 29.0429Z",
    fill: "url(#paint16_radial_2548_3751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13868 29.0429C6.42646 28.7006 6.83834 28.4866 7.28385 28.4478C7.72935 28.409 8.17204 28.5486 8.51468 28.8359L12.9727 32.5754L12.5977 31.2299C12.532 31.0063 12.5115 30.7719 12.5375 30.5403C12.5634 30.3087 12.6351 30.0846 12.7486 29.881C12.8621 29.6774 13.0149 29.4985 13.1983 29.3547C13.3816 29.2108 13.5918 29.1049 13.8165 29.0432C14.0412 28.9814 14.276 28.965 14.5071 28.995C14.7382 29.0249 14.961 29.1006 15.1626 29.2176C15.3641 29.3346 15.5404 29.4905 15.681 29.6764C15.8216 29.8622 15.9238 30.0742 15.9817 30.2999L17.0152 34.1084L18.2692 37.1264C18.2932 37.1824 18.3132 37.2384 18.3292 37.2944C18.7777 38.1569 19.0297 39.1409 19.0297 40.1849C19.0297 43.5989 16.3222 46.3649 12.9832 46.3649C11.5132 46.3649 10.1662 45.8309 9.11918 44.9399L2.39468 39.9944C2.12422 39.7958 1.91668 39.5235 1.79685 39.21C1.67702 38.8966 1.64998 38.5552 1.71895 38.2268C1.78792 37.8984 1.94999 37.5968 2.18579 37.3581C2.4216 37.1193 2.72116 36.9535 3.04868 36.8804L2.40968 36.3449C2.15571 36.1315 1.96699 35.8509 1.86516 35.5352C1.76332 35.2195 1.75249 34.8815 1.8339 34.5599C1.91531 34.2384 2.08567 33.9462 2.32546 33.717C2.56525 33.4878 2.86476 33.3308 3.18968 33.2639L2.99168 33.0989C2.80999 32.9512 2.6595 32.7688 2.54898 32.5624C2.43845 32.356 2.37009 32.1296 2.34788 31.8965C2.32566 31.6634 2.35004 31.4282 2.41959 31.2046C2.48915 30.9811 2.60248 30.7735 2.753 30.5942C2.90352 30.4148 3.08822 30.2672 3.29634 30.1598C3.50446 30.0525 3.73185 29.9877 3.96527 29.9691C4.19869 29.9505 4.43347 29.9786 4.65595 30.0516C4.87844 30.1246 5.08417 30.2411 5.26118 30.3944L5.99018 31.0049C5.62418 30.4049 5.66018 29.6114 6.13868 29.0429Z",
    fill: "url(#paint17_linear_2548_3751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13868 29.0429C6.42646 28.7006 6.83834 28.4866 7.28385 28.4478C7.72935 28.409 8.17204 28.5486 8.51468 28.8359L12.9727 32.5754L12.5977 31.2299C12.532 31.0063 12.5115 30.7719 12.5375 30.5403C12.5634 30.3087 12.6351 30.0846 12.7486 29.881C12.8621 29.6774 13.0149 29.4985 13.1983 29.3547C13.3816 29.2108 13.5918 29.1049 13.8165 29.0432C14.0412 28.9814 14.276 28.965 14.5071 28.995C14.7382 29.0249 14.961 29.1006 15.1626 29.2176C15.3641 29.3346 15.5404 29.4905 15.681 29.6764C15.8216 29.8622 15.9238 30.0742 15.9817 30.2999L17.0152 34.1084L18.2692 37.1264C18.2932 37.1824 18.3132 37.2384 18.3292 37.2944C18.7777 38.1569 19.0297 39.1409 19.0297 40.1849C19.0297 43.5989 16.3222 46.3649 12.9832 46.3649C11.5132 46.3649 10.1662 45.8309 9.11918 44.9399L2.39468 39.9944C2.12422 39.7958 1.91668 39.5235 1.79685 39.21C1.67702 38.8966 1.64998 38.5552 1.71895 38.2268C1.78792 37.8984 1.94999 37.5968 2.18579 37.3581C2.4216 37.1193 2.72116 36.9535 3.04868 36.8804L2.40968 36.3449C2.15571 36.1315 1.96699 35.8509 1.86516 35.5352C1.76332 35.2195 1.75249 34.8815 1.8339 34.5599C1.91531 34.2384 2.08567 33.9462 2.32546 33.717C2.56525 33.4878 2.86476 33.3308 3.18968 33.2639L2.99168 33.0989C2.80999 32.9512 2.6595 32.7688 2.54898 32.5624C2.43845 32.356 2.37009 32.1296 2.34788 31.8965C2.32566 31.6634 2.35004 31.4282 2.41959 31.2046C2.48915 30.9811 2.60248 30.7735 2.753 30.5942C2.90352 30.4148 3.08822 30.2672 3.29634 30.1598C3.50446 30.0525 3.73185 29.9877 3.96527 29.9691C4.19869 29.9505 4.43347 29.9786 4.65595 30.0516C4.87844 30.1246 5.08417 30.2411 5.26118 30.3944L5.99018 31.0049C5.62418 30.4049 5.66018 29.6114 6.13868 29.0429Z",
    fill: "url(#paint18_linear_2548_3751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13868 29.0429C6.42646 28.7006 6.83834 28.4866 7.28385 28.4478C7.72935 28.409 8.17204 28.5486 8.51468 28.8359L12.9727 32.5754L12.5977 31.2299C12.532 31.0063 12.5115 30.7719 12.5375 30.5403C12.5634 30.3087 12.6351 30.0846 12.7486 29.881C12.8621 29.6774 13.0149 29.4985 13.1983 29.3547C13.3816 29.2108 13.5918 29.1049 13.8165 29.0432C14.0412 28.9814 14.276 28.965 14.5071 28.995C14.7382 29.0249 14.961 29.1006 15.1626 29.2176C15.3641 29.3346 15.5404 29.4905 15.681 29.6764C15.8216 29.8622 15.9238 30.0742 15.9817 30.2999L17.0152 34.1084L18.2692 37.1264C18.2932 37.1824 18.3132 37.2384 18.3292 37.2944C18.7777 38.1569 19.0297 39.1409 19.0297 40.1849C19.0297 43.5989 16.3222 46.3649 12.9832 46.3649C11.5132 46.3649 10.1662 45.8309 9.11918 44.9399L2.39468 39.9944C2.12422 39.7958 1.91668 39.5235 1.79685 39.21C1.67702 38.8966 1.64998 38.5552 1.71895 38.2268C1.78792 37.8984 1.94999 37.5968 2.18579 37.3581C2.4216 37.1193 2.72116 36.9535 3.04868 36.8804L2.40968 36.3449C2.15571 36.1315 1.96699 35.8509 1.86516 35.5352C1.76332 35.2195 1.75249 34.8815 1.8339 34.5599C1.91531 34.2384 2.08567 33.9462 2.32546 33.717C2.56525 33.4878 2.86476 33.3308 3.18968 33.2639L2.99168 33.0989C2.80999 32.9512 2.6595 32.7688 2.54898 32.5624C2.43845 32.356 2.37009 32.1296 2.34788 31.8965C2.32566 31.6634 2.35004 31.4282 2.41959 31.2046C2.48915 30.9811 2.60248 30.7735 2.753 30.5942C2.90352 30.4148 3.08822 30.2672 3.29634 30.1598C3.50446 30.0525 3.73185 29.9877 3.96527 29.9691C4.19869 29.9505 4.43347 29.9786 4.65595 30.0516C4.87844 30.1246 5.08417 30.2411 5.26118 30.3944L5.99018 31.0049C5.62418 30.4049 5.66018 29.6114 6.13868 29.0429Z",
    fill: "url(#paint19_radial_2548_3751)"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53157 37.1464C4.15185 36.8697 3.67776 36.7552 3.21361 36.8281C2.74946 36.9009 2.33326 37.1552 2.05657 37.5349C1.77989 37.9146 1.66538 38.3887 1.73823 38.8529C1.81109 39.317 2.06535 39.7332 2.44507 40.0099L3.24907 40.5979C3.75028 40.9665 4.36181 41.1538 4.98345 41.1293C5.60509 41.1048 6.19996 40.8698 6.67057 40.4629L7.78657 39.4999L4.53157 37.1464Z",
    fill: "url(#paint20_linear_2548_3751)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.23305 37.7579C8.90605 37.9454 7.76605 38.3774 7.49905 38.6954C6.87205 39.4424 6.52405 39.6539 5.77555 39.0269L2.58055 36.3449C2.22174 36.0441 1.9971 35.6131 1.95603 35.1467C1.91496 34.6803 2.06083 34.2167 2.36155 33.8579C3.00355 33.0929 3.84655 33.0839 4.59955 33.7379L9.23305 37.7579Z",
    fill: "url(#paint21_linear_2548_3751)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0609 35.6718C10.4984 35.9763 10.1234 36.3288 9.53691 36.8208C8.91141 37.5678 8.52591 37.8978 7.77891 37.2708L3.02091 33.0993C2.83922 32.9515 2.68873 32.7692 2.5782 32.5627C2.46767 32.3563 2.39931 32.1299 2.3771 31.8968C2.35489 31.6637 2.37927 31.4285 2.44882 31.205C2.51837 30.9814 2.63171 30.7739 2.78223 30.5945C2.93275 30.4151 3.11744 30.2675 3.32557 30.1602C3.53369 30.0529 3.76108 29.988 3.9945 29.9694C4.22791 29.9509 4.4627 29.9789 4.68518 30.0519C4.90766 30.1249 5.1134 30.2415 5.29041 30.3948L6.01941 31.0053C6.11241 31.1593 6.23141 31.2973 6.37641 31.4193L11.0609 35.6718Z",
    fill: "url(#paint22_linear_2548_3751)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8.46249 28.7656C8.29721 28.6266 8.10518 28.5231 7.89828 28.4614C7.69138 28.3996 7.47401 28.381 7.25963 28.4067C7.04525 28.4323 6.83841 28.5017 6.65192 28.6105C6.46543 28.7193 6.30325 28.8653 6.17542 29.0393C6.04759 29.2133 5.95683 29.4117 5.90876 29.6221C5.86068 29.8326 5.85631 30.0508 5.89592 30.263C5.93553 30.4752 6.01828 30.6771 6.13904 30.8561C6.2598 31.0351 6.41601 31.1874 6.59799 31.3036L13.828 35.9296L13.003 32.5741L8.46249 28.7656Z",
    fill: "url(#paint23_radial_2548_3751)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78711 29.8066L12.3816 33.7906",
    stroke: "url(#paint24_linear_2548_3751)",
    strokeLinecap: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.42969 31.3066L9.02269 35.2906",
    stroke: "url(#paint25_linear_2548_3751)",
    strokeLinecap: "round"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.65625 34.3525L8.25075 38.3365",
    stroke: "url(#paint26_linear_2548_3751)",
    strokeLinecap: "round"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.65625 37.875L7.07625 40.383",
    stroke: "url(#paint27_linear_2548_3751)",
    strokeLinecap: "round"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8827 29.0592C41.7403 28.8894 41.5659 28.7493 41.3693 28.6469C41.1727 28.5445 40.9579 28.4819 40.7372 28.4625C40.5164 28.4431 40.294 28.4675 40.0826 28.5341C39.8712 28.6007 39.675 28.7083 39.5052 28.8507L35.0472 32.5917L35.4222 31.2462C35.4879 31.0226 35.5084 30.7882 35.4825 30.5566C35.4565 30.325 35.3848 30.1008 35.2713 29.8973C35.1579 29.6937 35.005 29.5148 34.8216 29.3709C34.6383 29.2271 34.4281 29.1212 34.2034 29.0594C33.9787 28.9977 33.7439 28.9813 33.5128 29.0112C33.2817 29.0412 33.0589 29.1169 32.8573 29.2339C32.6558 29.3508 32.4795 29.5068 32.3389 29.6926C32.1983 29.8785 32.0961 30.0904 32.0382 30.3162L31.0062 34.1247L29.7507 37.1427C29.7274 37.1979 29.7073 37.2545 29.6907 37.3122C29.2301 38.2055 28.9899 39.1961 28.9902 40.2012C28.9902 43.6152 31.6977 46.3812 35.0382 46.3812C36.5082 46.3812 37.8552 45.8472 38.9022 44.9562L45.6267 40.0107C45.8972 39.812 46.1047 39.5397 46.2246 39.2263C46.3444 38.9128 46.3714 38.5715 46.3025 38.2431C46.2335 37.9147 46.0714 37.6131 45.8356 37.3743C45.5998 37.1356 45.3003 36.9698 44.9727 36.8967L45.6117 36.3612C45.8657 36.1478 46.0544 35.8672 46.1563 35.5515C46.2581 35.2358 46.2689 34.8978 46.1875 34.5762C46.1061 34.2546 45.9357 33.9625 45.696 33.7333C45.4562 33.5041 45.1567 33.347 44.8317 33.2802L45.0282 33.1152C45.3786 32.8118 45.5956 32.3827 45.6324 31.9207C45.6692 31.4587 45.5228 31.0007 45.2249 30.6457C44.9269 30.2907 44.5013 30.067 44.0399 30.023C43.5785 29.9791 43.1184 30.1183 42.7587 30.4107L42.0312 31.0212C42.3972 30.4212 42.3612 29.6277 41.8827 29.0592Z",
    fill: "url(#paint28_radial_2548_3751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8827 29.0592C41.7403 28.8894 41.5659 28.7493 41.3693 28.6469C41.1727 28.5445 40.9579 28.4819 40.7372 28.4625C40.5164 28.4431 40.294 28.4675 40.0826 28.5341C39.8712 28.6007 39.675 28.7083 39.5052 28.8507L35.0472 32.5917L35.4222 31.2462C35.4879 31.0226 35.5084 30.7882 35.4825 30.5566C35.4565 30.325 35.3848 30.1008 35.2713 29.8973C35.1579 29.6937 35.005 29.5148 34.8216 29.3709C34.6383 29.2271 34.4281 29.1212 34.2034 29.0594C33.9787 28.9977 33.7439 28.9813 33.5128 29.0112C33.2817 29.0412 33.0589 29.1169 32.8573 29.2339C32.6558 29.3508 32.4795 29.5068 32.3389 29.6926C32.1983 29.8785 32.0961 30.0904 32.0382 30.3162L31.0062 34.1247L29.7507 37.1427C29.7274 37.1979 29.7073 37.2545 29.6907 37.3122C29.2301 38.2055 28.9899 39.1961 28.9902 40.2012C28.9902 43.6152 31.6977 46.3812 35.0382 46.3812C36.5082 46.3812 37.8552 45.8472 38.9022 44.9562L45.6267 40.0107C45.8972 39.812 46.1047 39.5397 46.2246 39.2263C46.3444 38.9128 46.3714 38.5715 46.3025 38.2431C46.2335 37.9147 46.0714 37.6131 45.8356 37.3743C45.5998 37.1356 45.3003 36.9698 44.9727 36.8967L45.6117 36.3612C45.8657 36.1478 46.0544 35.8672 46.1563 35.5515C46.2581 35.2358 46.2689 34.8978 46.1875 34.5762C46.1061 34.2546 45.9357 33.9625 45.696 33.7333C45.4562 33.5041 45.1567 33.347 44.8317 33.2802L45.0282 33.1152C45.3786 32.8118 45.5956 32.3827 45.6324 31.9207C45.6692 31.4587 45.5228 31.0007 45.2249 30.6457C44.9269 30.2907 44.5013 30.067 44.0399 30.023C43.5785 29.9791 43.1184 30.1183 42.7587 30.4107L42.0312 31.0212C42.3972 30.4212 42.3612 29.6277 41.8827 29.0592Z",
    fill: "url(#paint29_linear_2548_3751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8827 29.0592C41.7403 28.8894 41.5659 28.7493 41.3693 28.6469C41.1727 28.5445 40.9579 28.4819 40.7372 28.4625C40.5164 28.4431 40.294 28.4675 40.0826 28.5341C39.8712 28.6007 39.675 28.7083 39.5052 28.8507L35.0472 32.5917L35.4222 31.2462C35.4879 31.0226 35.5084 30.7882 35.4825 30.5566C35.4565 30.325 35.3848 30.1008 35.2713 29.8973C35.1579 29.6937 35.005 29.5148 34.8216 29.3709C34.6383 29.2271 34.4281 29.1212 34.2034 29.0594C33.9787 28.9977 33.7439 28.9813 33.5128 29.0112C33.2817 29.0412 33.0589 29.1169 32.8573 29.2339C32.6558 29.3508 32.4795 29.5068 32.3389 29.6926C32.1983 29.8785 32.0961 30.0904 32.0382 30.3162L31.0062 34.1247L29.7507 37.1427C29.7274 37.1979 29.7073 37.2545 29.6907 37.3122C29.2301 38.2055 28.9899 39.1961 28.9902 40.2012C28.9902 43.6152 31.6977 46.3812 35.0382 46.3812C36.5082 46.3812 37.8552 45.8472 38.9022 44.9562L45.6267 40.0107C45.8972 39.812 46.1047 39.5397 46.2246 39.2263C46.3444 38.9128 46.3714 38.5715 46.3025 38.2431C46.2335 37.9147 46.0714 37.6131 45.8356 37.3743C45.5998 37.1356 45.3003 36.9698 44.9727 36.8967L45.6117 36.3612C45.8657 36.1478 46.0544 35.8672 46.1563 35.5515C46.2581 35.2358 46.2689 34.8978 46.1875 34.5762C46.1061 34.2546 45.9357 33.9625 45.696 33.7333C45.4562 33.5041 45.1567 33.347 44.8317 33.2802L45.0282 33.1152C45.3786 32.8118 45.5956 32.3827 45.6324 31.9207C45.6692 31.4587 45.5228 31.0007 45.2249 30.6457C44.9269 30.2907 44.5013 30.067 44.0399 30.023C43.5785 29.9791 43.1184 30.1183 42.7587 30.4107L42.0312 31.0212C42.3972 30.4212 42.3612 29.6277 41.8827 29.0592Z",
    fill: "url(#paint30_linear_2548_3751)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.8827 29.0592C41.7403 28.8894 41.5659 28.7493 41.3693 28.6469C41.1727 28.5445 40.9579 28.4819 40.7372 28.4625C40.5164 28.4431 40.294 28.4675 40.0826 28.5341C39.8712 28.6007 39.675 28.7083 39.5052 28.8507L35.0472 32.5917L35.4222 31.2462C35.4879 31.0226 35.5084 30.7882 35.4825 30.5566C35.4565 30.325 35.3848 30.1008 35.2713 29.8973C35.1579 29.6937 35.005 29.5148 34.8216 29.3709C34.6383 29.2271 34.4281 29.1212 34.2034 29.0594C33.9787 28.9977 33.7439 28.9813 33.5128 29.0112C33.2817 29.0412 33.0589 29.1169 32.8573 29.2339C32.6558 29.3508 32.4795 29.5068 32.3389 29.6926C32.1983 29.8785 32.0961 30.0904 32.0382 30.3162L31.0062 34.1247L29.7507 37.1427C29.7274 37.1979 29.7073 37.2545 29.6907 37.3122C29.2301 38.2055 28.9899 39.1961 28.9902 40.2012C28.9902 43.6152 31.6977 46.3812 35.0382 46.3812C36.5082 46.3812 37.8552 45.8472 38.9022 44.9562L45.6267 40.0107C45.8972 39.812 46.1047 39.5397 46.2246 39.2263C46.3444 38.9128 46.3714 38.5715 46.3025 38.2431C46.2335 37.9147 46.0714 37.6131 45.8356 37.3743C45.5998 37.1356 45.3003 36.9698 44.9727 36.8967L45.6117 36.3612C45.8657 36.1478 46.0544 35.8672 46.1563 35.5515C46.2581 35.2358 46.2689 34.8978 46.1875 34.5762C46.1061 34.2546 45.9357 33.9625 45.696 33.7333C45.4562 33.5041 45.1567 33.347 44.8317 33.2802L45.0282 33.1152C45.3786 32.8118 45.5956 32.3827 45.6324 31.9207C45.6692 31.4587 45.5228 31.0007 45.2249 30.6457C44.9269 30.2907 44.5013 30.067 44.0399 30.023C43.5785 29.9791 43.1184 30.1183 42.7587 30.4107L42.0312 31.0212C42.3972 30.4212 42.3612 29.6277 41.8827 29.0592Z",
    fill: "url(#paint31_radial_2548_3751)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4909 37.1426C43.8702 36.8673 44.3434 36.754 44.8062 36.8276C45.2691 36.9011 45.6838 37.1556 45.9591 37.5349C46.2344 37.9142 46.3478 38.3874 46.2742 38.8503C46.2006 39.3131 45.9462 39.7278 45.5669 40.0031L44.6219 40.6916C44.2876 40.9347 43.9053 41.1036 43.5005 41.1871C43.0957 41.2707 42.6778 41.2669 42.2746 41.176C41.8713 41.0852 41.4922 40.9093 41.1623 40.6602C40.8325 40.4112 40.5596 40.0946 40.3619 39.7316L40.2344 39.4991L43.4909 37.1426Z",
    fill: "url(#paint32_linear_2548_3751)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1341 37.5269C38.6511 37.9454 39.0531 38.7104 39.3186 39.0269C39.9456 39.7739 41.4981 39.6539 42.2451 39.0269L45.4416 36.3449C46.1886 35.7179 46.4136 34.5959 45.7866 33.8489C45.1146 33.0479 44.1561 33.1064 43.3701 33.7979L39.1341 37.5269Z",
    fill: "url(#paint33_linear_2548_3751)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7547 34.8183C37.0017 35.4618 37.2522 36.4533 37.7547 37.0533C38.3817 37.8003 39.4947 37.8978 40.2417 37.2708L44.9997 33.0993C45.1814 32.9515 45.3319 32.7692 45.4424 32.5627C45.5529 32.3563 45.6213 32.1299 45.6435 31.8968C45.6657 31.6637 45.6413 31.4285 45.5718 31.205C45.5022 30.9814 45.3889 30.7739 45.2384 30.5945C45.0879 30.4151 44.9032 30.2675 44.695 30.1602C44.4869 30.0529 44.2595 29.988 44.0261 29.9694C43.7927 29.9509 43.5579 29.9789 43.3354 30.0519C43.1129 30.1249 42.9072 30.2415 42.7302 30.3948L42.0027 31.0053C41.9076 31.1621 41.7869 31.3021 41.6457 31.4193L37.7547 34.8183Z",
    fill: "url(#paint34_linear_2548_3751)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4647 28.8445C39.8091 28.5594 40.2518 28.4211 40.6972 28.4594C41.1427 28.4977 41.5553 28.7095 41.846 29.0492C42.1367 29.3889 42.2822 29.8293 42.2512 30.2753C42.2202 30.7213 42.0151 31.1373 41.6802 31.4335L38.3997 34.297C37.0107 35.509 34.8537 34.4095 35.0187 32.572L39.4647 28.8445Z",
    fill: "url(#paint35_linear_2548_3751)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_f_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6581 31.1501C34.1692 31.4946 34.8331 31.4035 35.141 30.9467C35.4489 30.4899 35.2842 29.8403 34.7731 29.4958C34.262 29.1513 33.5981 29.2424 33.2901 29.6992C32.9822 30.1561 33.147 30.8056 33.6581 31.1501Z",
    fill: "url(#paint36_radial_2548_3751)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8646 30.4432C40.1448 31.042 40.8385 31.309 41.414 31.0397C41.9895 30.7705 42.2289 30.0667 41.9487 29.468C41.6685 28.8692 40.9749 28.6021 40.3993 28.8714C39.8238 29.1407 39.5844 29.8444 39.8646 30.4432Z",
    fill: "url(#paint37_radial_2548_3751)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7048 32.0505C43.985 32.6493 44.596 32.9551 45.0694 32.7336C45.5429 32.512 45.6996 31.847 45.4194 31.2482C45.1392 30.6495 44.5283 30.3437 44.0548 30.5652C43.5814 30.7868 43.4247 31.4518 43.7048 32.0505Z",
    fill: "url(#paint38_radial_2548_3751)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_f_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2595 35.3103C44.5397 35.9091 45.1507 36.2149 45.6241 35.9933C46.0976 35.7718 46.2543 35.1068 45.9741 34.508C45.6939 33.9092 45.083 33.6034 44.6095 33.825C44.136 34.0465 43.9794 34.7115 44.2595 35.3103Z",
    fill: "url(#paint39_radial_2548_3751)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4236 38.9441C44.7038 39.5429 45.3147 39.8487 45.7882 39.6271C46.2617 39.4056 46.4184 38.7406 46.1382 38.1418C45.858 37.543 45.247 37.2372 44.7736 37.4588C44.3001 37.6803 44.1434 38.3453 44.4236 38.9441Z",
    fill: "url(#paint40_radial_2548_3751)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_2548_3751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6426 34.6875C37.3141 35.8125 39.5176 38.5785 39.5176 41.3445",
    stroke: "#FFEA6E",
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2548_3751",
    x: 26.9062,
    y: 12.5605,
    width: 9.5625,
    height: 6.56445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2548_3751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2548_3751",
    x: 10.9688,
    y: 12.5605,
    width: 9.5625,
    height: 6.56445,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2548_3751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_2548_3751",
    x: 1.68164,
    y: 26.4414,
    width: 19.3477,
    height: 19.9238,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2548_3751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_2548_3751",
    x: 6.28711,
    y: 28.3066,
    width: 7.59375,
    height: 6.98438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_2548_3751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_2548_3751",
    x: 2.92969,
    y: 29.8066,
    width: 7.59375,
    height: 6.98438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_2548_3751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_2548_3751",
    x: 2.15625,
    y: 32.8525,
    width: 7.59375,
    height: 6.98438,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_2548_3751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_2548_3751",
    x: 2.15625,
    y: 36.375,
    width: 6.41992,
    height: 5.50781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_2548_3751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_2548_3751",
    x: 28.9902,
    y: 26.4561,
    width: 19.3496,
    height: 19.9248,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2548_3751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_f_2548_3751",
    x: 32.6348,
    y: 28.7871,
    width: 3.16211,
    height: 3.07227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2548_3751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_2548_3751",
    x: 39.248,
    y: 28.2666,
    width: 3.31836,
    height: 3.37793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2548_3751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_2548_3751",
    x: 43.0664,
    y: 29.9932,
    width: 2.99219,
    height: 3.3125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2548_3751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_f_2548_3751",
    x: 43.6211,
    y: 33.2529,
    width: 2.99219,
    height: 3.3125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2548_3751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_2548_3751",
    x: 43.7852,
    y: 36.8867,
    width: 2.99219,
    height: 3.3125,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.25,
    result: "effect1_foregroundBlur_2548_3751"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_2548_3751",
    x: 32.6426,
    y: 32.6875,
    width: 8.875,
    height: 10.6572,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75,
    result: "effect1_foregroundBlur_2548_3751"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2503 13.4994) rotate(132.839) scale(56.2549)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2482 13.501) rotate(131.878) scale(58.423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#FFB02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F70A8D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.999 18.7496) rotate(101.31) scale(26.7699 34.2871)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.788,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.973,
    stopColor: "#FF7DCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27 21) rotate(135) scale(61.5183)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.315,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9999 25.5011) rotate(77.692) scale(42.2203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#7D6133",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#715B32"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.75 24.75) rotate(55.713) scale(19.9702 14.4755)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB847",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.75 27) rotate(9.86582) scale(17.5089)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA64B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FFAE46",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.2501 22.5004) rotate(43.971) scale(88.5793)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.185,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.8749 -6.84486) rotate(96.176) scale(50.5434)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#F59639",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68354"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.9969 22.4235) rotate(89.995) scale(5.88311)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF63C4",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59639",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.00059 22.4233) rotate(89.995) scale(5.88311)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E840A8",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F59639",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24 18.9) rotate(90) scale(10.8 11.8078)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#4E2553"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#5B4852"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4E2553"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7492 15.0949) rotate(124.912) scale(5.48759 9.85134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA7A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#CA7A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8107 15.0949) rotate(124.912) scale(5.48758 9.85134)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA7A1B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.634,
    stopColor: "#CA7A1B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.75 16.782) rotate(-91.3479) scale(11.9564 14.7415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#482641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#503A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#483637"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.25 16.782) rotate(-91.3479) scale(11.9564 14.7415)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#482641"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276,
    stopColor: "#503A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#483637"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-1.08682 27.5294) rotate(42.3946) scale(41.745 41.6199)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#F9AF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    stopColor: "#FFC83C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2548_3751",
    x1: 23.5312,
    y1: 34.9694,
    x2: 12.6952,
    y2: 39.5624,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FFF478"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#FFF478",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2548_3751",
    x1: 25.2262,
    y1: 16.1399,
    x2: 4.47667,
    y2: 47.0999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#FF63C4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#FF63C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.70618 25.9694) rotate(67.2716) scale(24.75 19.2093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#FD61C2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#FF63C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2548_3751",
    x1: 4.75657,
    y1: 36.2344,
    x2: 3.92857,
    y2: 37.4974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#83480A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#CD7313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9428",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2548_3751",
    x1: 7.21855,
    y1: 34.4759,
    x2: 6.03955,
    y2: 35.9339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#83480A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#CD7313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9428",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2548_3751",
    x1: 9.09291,
    y1: 31.9218,
    x2: 7.69641,
    y2: 33.4698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#83480A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#CD7313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9428",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.2955 29.9541) rotate(152.835) scale(4.00417 9.94699)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#83480A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#CD7313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9428",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2548_3751",
    x1: 5.86561,
    y1: 29.8066,
    x2: 10.7796,
    y2: 37.5436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FFF478",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#FFF478",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2548_3751",
    x1: 2.50819,
    y1: 31.3066,
    x2: 7.42219,
    y2: 39.0436,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FFF478",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#FFF478",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2548_3751",
    x1: 1.73475,
    y1: 34.3525,
    x2: 6.64875,
    y2: 42.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FFF478",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#FFF478",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2548_3751",
    x1: 1.73475,
    y1: 37.875,
    x2: 6.64875,
    y2: 45.6135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FFF478",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#FFF478",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.1076 27.5439) rotate(137.605) scale(41.745 41.6199)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#F9AF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#FFD362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#F9AF20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2548_3751",
    x1: 25.9677,
    y1: 36.4692,
    x2: 34.6857,
    y2: 37.4202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.214,
    stopColor: "#CC6C07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#EE891E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FA9428",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2548_3751",
    x1: 22.7937,
    y1: 16.1562,
    x2: 43.5432,
    y2: 47.1162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#FF63C4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#FF63C4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3149 25.9858) rotate(112.728) scale(24.75 19.2093)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.776,
    stopColor: "#FD61C2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#FF63C4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2548_3751",
    x1: 43.4129,
    y1: 36.0071,
    x2: 44.2229,
    y2: 37.2506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#83480A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#CD7313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9428",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2548_3751",
    x1: 40.5261,
    y1: 34.1714,
    x2: 41.9541,
    y2: 35.7614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#83480A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#CD7313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9428",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2548_3751",
    x1: 38.9862,
    y1: 31.4928,
    x2: 40.4652,
    y2: 33.2703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.386,
    stopColor: "#83480A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.545,
    stopColor: "#CD7313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA9428",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2548_3751",
    x1: 39.1797,
    y1: 27.874,
    x2: 40.4412,
    y2: 29.4085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#EE891E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.865,
    stopColor: "#FA9428",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2136 30.3236) rotate(152.661) scale(1.24407 1.3677)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FAF194",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#FFF478",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.9077 29.9571) rotate(-178.093) scale(1.41161 1.49032)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FAF194",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#FFF478",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5641 31.6501) rotate(-173.32) scale(1.21698 1.42203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.391,
    stopColor: "#FAF194",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#FFF478",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.1168 34.9092) rotate(-173.32) scale(1.21698 1.42203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FAF194",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#FFF478",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_2548_3751",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2809 38.5429) rotate(-173.32) scale(1.21698 1.42203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.328,
    stopColor: "#FAF194",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.724,
    stopColor: "#FFF478",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsmile5);
export default __webpack_public_path__ + "static/media/Claim smile 5.4378390499898d99966ece5416bb9689.svg";
export { ForwardRef as ReactComponent };